import { Directive, HostListener, ElementRef, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[trimOnBlur]'
})
export class TrimOnBlurDirective {
  constructor(private el: ElementRef, @Optional() private control: NgControl) {}

  @HostListener('blur')
  onBlur() {
    const value = this.el.nativeElement.value;
    if (typeof value === 'string') {
      const trimmed = value.trim();
      this.el.nativeElement.value = trimmed;
      if (this.control && this.control.control) {
        this.control.control.setValue(trimmed, { emitEvent: false });
      }
    }
  }
}